import FullPageFlow from './full-page-flow';

export default FullPageFlow;
